import * as React from 'react';
import './SubmitOriginalFilesTable.scss';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface SubmitOriginalFilesTableProps {
    files: File[];
    fileDeleteHandler: (fileId: string) => void;
}

const SubmitOriginalFilesTable: React.FC<SubmitOriginalFilesTableProps> = ({ files, fileDeleteHandler }) => {
    return (
        <TableContainer className='table-container' component={Paper}>
            <Table className='table' aria-label="simple table" size='small'>
                <TableHead className='table-head'>
                    <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell align="left">File Name</TableCell>
                        <TableCell align="right">Type</TableCell>
                        <TableCell align="right">Size</TableCell>
                        <TableCell align="right">Remove</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody className='table-body'>
                    {files.map((file, index) => (
                        <TableRow
                            className='table-content-row'
                            key={file.name}
                        >
                            <TableCell component="th" scope="row" data-label="S.No">
                                {index+1}
                            </TableCell>
                            <TableCell align="left" data-label="File Name">{file.name}</TableCell>
                            <TableCell align="right" data-label="Type">{file.type}</TableCell>
                            <TableCell align='right' data-label="Size">{((file.size / (1024 * 1024 * 1024)) >= 1) ? (file.size / (1024 * 1024 * 1024)).toFixed(2) + ' GB' 
                                                                                                : ((file.size / (1024 * 1024) >= 1)) ? (file.size / (1024 * 1024)).toFixed(2) + ' MB' 
                                                                                                                                     : ((file.size / 1024 >= 1)) ? (file.size / 1024).toFixed(2) + ' KB' 
                                                                                                                                                                 : file.size + ' B'}
                            </TableCell>
                            <TableCell align="right" data-label="Remove"><IconButton className='delete-button' onClick={() => fileDeleteHandler(file.name)}><DeleteIcon></DeleteIcon></IconButton></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SubmitOriginalFilesTable;